import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const StyMarkdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
  max-height: 50vh;
  overflow-y: auto;
  padding-right: ${SPACING._8};
  color: ${({ theme }) => theme.neutral[200]};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.neutral[0]};
  }

  h1 {
    font-size: 20px;
  }

  h2 {
    font-size: 17px;
    margin-top: ${SPACING._8};
  }

  h3 {
    font-size: 15px;
    margin-top: ${SPACING._8};
  }

  p,
  span,
  ol,
  ul,
  li {
    color: ${({ theme }) => theme.neutral[200]};
    font-size: 14px;
    line-height: 1.5;
  }

  ol,
  ul {
    padding-left: ${SPACING._24};
  }

  strong {
    color: ${({ theme }) => theme.neutral[0]};
  }

  a {
    color: ${({ theme }) => theme.green[500]};
  }
`;

export const StyCheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING._8};
  padding-top: ${SPACING._16};
`;
